import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// services
import { EventsService } from '../../core/services/events-service/events.service';

// interfaces
// interfaces
import { Event } from '../interfaces';
import { ProfileService } from '../../core/services/profile-service/profile.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'eze-registration',
	templateUrl: './registration.component.html',
	styleUrls: ['./registration.component.css'],
})
export class RegistrationComponent implements OnInit, OnDestroy {
	profile;
	profileSubscription: Subscription;

	get eventDetails(): Event {
		return this.eventsService.eventData;
	}

	get maintenanceMode(): boolean {
		return (
			this.eventDetails &&
			this.eventDetails.maintenance &&
			this.eventDetails.maintenance === true
		);
	}

	constructor(
		private route: ActivatedRoute,
		private eventsService: EventsService,
		private profileService: ProfileService
	) {}

	ngOnInit() {
		const eventId = this.route.snapshot.params.id;
		this.getEventData(eventId);
		this.profileSubscription = this.profileService.profile.subscribe(
			(profile) => {
				this.profile = profile;
			}
		);
	}

	getEventData(eventId: string) {
		// this.http.get('/api/v1/events/' + eventId)
		this.eventsService.getEventData(eventId).subscribe(
			(res: Event) => {
				this.eventsService.waiver.header = res.waiver_description;
				this.getWaiverText(res.waiver_text);
			},
			(err) => {
				// TODO - show error alert
				// console.log('err =', err);
			}
		);
	}

	getWaiverText(url: string) {
		this.eventsService.getWaiverText(url).subscribe(
			(response: string) => {
				this.eventsService.waiver.text = response;
			},
			(err) => {
				// TODO - show alert somewhere?
				// console.log('waiver text err =', err);
			}
		);
	}

	getProfile() {
		this.profileService.getProfile().subscribe();
	}

	ngOnDestroy() {
		if (this.profileSubscription) {
			this.profileSubscription.unsubscribe();
		}
	}
}
